export const searchInput = {
  stringOptions: {
    include_match: "Include match",
    match: "Complete match",
    forward_match: "Forward match",
    backward_match: "Backward match",
  },
};
